module.exports = __webpack_public_path__ + "img/遂宁市中心医院.bef6bca6.png";